import { SITE_CONFIG } from "../../app/config";
import { useHead, buildBreadcrumbSchema } from "../../seo";
import { glossaryTerms, GLOSSARY_CATEGORIES, getTermsByCategory } from "./glossary-data";
import type { GlossaryCategory } from "./glossary-data";

const categoryIcons: Record<GlossaryCategory, string> = {
  Formats: "💿",
  Equipment: "🔊",
  Collecting: "📦",
  Audio: "🎧",
  Community: "🌍",
};

export const GlossaryIndex = (): JSX.Element => {
  useHead({
    title: "Music Glossary — Vinyl, CD & Physical Music Terms",
    description:
      "Learn the essential vocabulary of vinyl records, CDs, and physical music collecting. From audiophile terms to collecting jargon — the complete glossary for music lovers.",
    path: "/glossary",
    ogType: "website",
    jsonLd: buildBreadcrumbSchema([
      { name: "Home", url: "/" },
      { name: "Glossary", url: "/glossary" },
    ]),
  });

  return (
    <div className="shell">
      <div className="pseo-page">
        <header className="pseo-header">
          <a href="/" className="blog-back">
            ← Back to {SITE_CONFIG.name}
          </a>
          <h1 className="pseo-title">Music Glossary</h1>
          <p className="pseo-subtitle">
            The essential vocabulary for vinyl records, CDs, and physical music collecting.{" "}
            <strong>{glossaryTerms.length} terms</strong> every music lover should know.
          </p>
        </header>

        <div className="glossary-categories">
          {GLOSSARY_CATEGORIES.map((category) => {
            const terms = getTermsByCategory(category);
            return (
              <section key={category} className="glossary-category-section">
                <h2 className="glossary-category-heading">
                  <span className="glossary-category-icon">{categoryIcons[category]}</span>
                  {category}
                  <span className="glossary-category-count">{terms.length}</span>
                </h2>
                <div className="glossary-term-grid">
                  {terms.map((term) => (
                    <a
                      key={term.slug}
                      href={`/glossary/${term.slug}`}
                      className="glossary-term-card"
                    >
                      <h3 className="glossary-term-card-title">{term.term}</h3>
                      <p className="glossary-term-card-desc">{term.shortDefinition}</p>
                      <span className="glossary-term-card-link">Read definition →</span>
                    </a>
                  ))}
                </div>
              </section>
            );
          })}
        </div>

        <footer className="pseo-footer">
          <div className="blog-cta">
            <h3>Turn Your Spotify Playlists Into Physical Gold</h3>
            <p>
              Now that you know the lingo, paste any playlist and get a shopping list of vinyl &
              CDs. Free, instant, no signup required.
            </p>
            <a href="/" className="blog-cta-button">
              Try {SITE_CONFIG.name} →
            </a>
          </div>
          <div className="pseo-nav-links">
            <a href="/blog">Blog</a>
            <a href="/compare">Compare Formats</a>
            <a href="/">Home</a>
          </div>
        </footer>
      </div>
    </div>
  );
};
